var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.type,{tag:"component",attrs:{"options":_vm.options,"submitSimulateApi":_vm.submitSimulateApi,"close":_vm.close},on:{"confirm":_vm.handleConfirm}})}
var staticRenderFns = []

export { render, staticRenderFns }